import { Spinner } from '@mybridge/ui';
import { Box, Flex } from '@mybridge/ui/layout';
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@mybridge/ui/popover';
import { Portal } from '@mybridge/ui';

export const InsightPopover = ({
  children,
  content,
  wrapperProps,
  triggerProps,
  reactionLoading=false,
  ...props
}) => {
  return (
    <Popover placement="top" trigger="hover" {...(wrapperProps ?? {})}>
      <PopoverTrigger {...(triggerProps ?? {})}>{children}</PopoverTrigger>
      {(Array.isArray(content) && content?.length > 0 || reactionLoading) && 
      <Portal>
        <PopoverContent w="auto" minW="20" bg="black" border="none">
          <PopoverArrow bg="black" />
          <PopoverBody bg="transparent" color="white" fontSize="sm" {...props}>
            {reactionLoading ? (
              <Flex justifyContent="center" alignItems="center" h="100%">
                <Spinner size="sm"/>
              </Flex>
            ) : (
              content
            )}
          </PopoverBody>
        </PopoverContent>
      </Portal>
      }
    </Popover>
  );
};
